<template>
  <div v-if="visible" :id="def.id">
    <v-menu v-if="def &&
    def.actionType &&
    def.actionType.name === 'ECore.Def.DefEnums.atActionList'
    " offset-y eager close-on-content-click>
      <template #activator="{ on, attrs }">
        <v-btn color="P1" dark v-bind="attrs" :outlined="def.actionLocation &&
    def.actionLocation.name === 'ECore.Def.DefEnums.Header'
    " :text="!def.actionLocation" class="elevation-0" height="31" v-on="on">
          <v-icon v-if="def.iconName" class="ml-1" :class="{ 'black--text': !def.label }">
            {{ def.iconName }}
          </v-icon>
          {{ $t(def) }}
        </v-btn>
      </template>
      <v-list class="pa-0">
        <AppButton v-for="(item, index) in def.menuItems" :key="index" :def="item" width="100%" :model="model" text
          style="border-bottom: solid 1px #2969e3" class="text--white"></AppButton>
      </v-list>
    </v-menu>
    <v-btn v-else :disabled="getDisabled" color="P1 BG1--text" v-bind="$attrs" class="elevation-0" height="31"
      :class="{ 'P1--text': $vuetify.theme.dark }" v-on="mergeListeners()" @click="click">
      <slot name="label"></slot>
      <span>
        <v-icon v-if="def && def.iconName && !getDisabled" class="ml-2 font-weight-thin"
          :class="{ 'G2--text': !def.label }">{{ def.iconName }}</v-icon>

        <v-tooltip v-else-if="getDisabled" class="px-0 py-2" top>
          <ul class="text--white pa-0 mr-3" style="width: 45vh">
            <li v-for="(msg, index) in ErrorMessages" :key="index">
              {{ msg }}
            </li>
          </ul>

          <template v-if="scriptErrorMessages.length > 0" #activator="{ on, attrs }">
            <v-icon style="cursor: pointer !important; pointer-events: visible" v-bind="attrs" v-on="on">
              {{
    def.inActiveCollection
      ? def.iconName
      : "mdi-alert-circle-outline"
  }}
            </v-icon>
          </template>
        </v-tooltip>

      </span>
      <span v-if="def && def.actionType && !$slots.label">
        <span v-if="def &&
    def.actionType &&
    def.actionType.name !== 'ECore.Def.DefEnums.atIcon' &&
    def.actionType.name !== 'ECore.Def.DefEnums.atRowAction'
    ">{{ label }}</span>
      </span>
    </v-btn>
  </div>
</template>

<script>
import { isEmpty } from "@/utils/object";
import { invokeAction, getReport } from "../../../apis";
import { fetchFormData, invokeFn } from "@/apis";
import AbrEventsOff from "@/mixins/AbrEventsOff";
import { isEqual } from "lodash";

export default {
  name: "AppButton",
  mixins:[ AbrEventsOff ],
  inject: ["changeFormMode"],
  props: {
    disabled: {
      default: () => false,
    },
    def: {},
    model: {},
    scriptErrorMessages: {
      default: () => [],
    },
  },
  data: function () {
    return {
      target: null,
      Model: this.model,
      inputEvents: {},
      visible: true,
      ErrorMessages: [],
      Actionres: {},
      currentState: {},
      actionActiveList:[],
    };
  },
  computed: {
    currentFormFinder() {
      const activeTab = this.$store.state.tabManagement.tabs[this.$store.state.tabManagement.activeTab]
      if (!!activeTab && isEmpty(activeTab)) return {}
      else {
        const modal = this.deepCopy(activeTab.modalForm).reverse().find((modal) => modal.show)
        return isEmpty(modal) ? activeTab : modal
      }
      // return this.$store.getters.getCurrentForm
    },
    getDisabled() {
      return (
        this.disabled ||
        this.$store.state.isLoading ||
        (this.ErrorMessages && this.ErrorMessages.filter((a) => a).length > 0)
      );
    },
    label() {
      if (this.def?.form && this.def.name === "fcaSubmitButton")
        //TODO not by name
        return this.$t(`ECore.Cmn.FormModeButtons.${this.$formMode}`);
      return this.$t(this.def);
    },
    getTarget() {
      return this.def &&
        this.def.name !== "fcaCancelButton" &&
        this.def.name !== "fcaSubmitButton" &&
        (!this.def.target ||
          (this.def.target &&
            this.def.target.name !== "ECore.Def.DefEnums.atModal" &&
            this.def.target.name !== "ECore.Def.DefEnums.atPage"))
        ? this.target
        : undefined;
    },
  },
  updated() { 
    if (this.def?.action) {
      let p = this.$parent;
      let form;
      while (p) {
        if (p.def?.kind === 'TForm') {
          form = p.def.id;
          break;
        }
        p = p.$parent;
      }
      this.$eventBus.$on("Pass-State-Machine", (payload) => {
        const { state, formID } = payload
        if(String(this.def.id).includes(formID)){
          this.currentState = state; // Update the injected data when the event is received
        }
      });
      if (!this.currentState) return;
      this.checkVisibleByState(this.currentState);
    }
  },
  async created() {
    if (!this.def) return;
    this.$eventBus.$on("ButtonRenderVisibility", (payload) => {
      const { state, formID } = payload
      if(String(this.def.id).includes(formID)){
        this.checkVisibleByState(state);
      }
    });
    this.visible &= await this.$checkVisibility(this.def);
    this.$watch("$store.getters.getCurrentForm.mode", async () => {
      this.visible = await this.$checkVisibility(this.def);
    });
    this.$watch(
      "model",
      async () => {
        this.Model = this.model;
        if (
          !this.$store.getters?.getActiveTab?.form?.product &&
          (this.def.actionType?.name === "ECore.Def.DefEnums.atRowAction" ||
            this.def.actionLocation?.name === "ECore.Def.DefEnums.Footer") ||
          (this.def.actionLocation?.name === "ECore.Def.DefEnums.Header")
        )
          this.visible = await this.$checkVisibility(this.def);

        if (this.def.labelExpr) {
          const label = await this.$eval(this.def.labelExpr);
          if (!label) return;
          this.def.label.resourceKey = await this.$eval(this.def.labelExpr);
        }
      },
      { deep: true, immediate: true }
    );
    // this.$watch('model' , () => this.Model = this.model);
    this.def.eventHandlers &&
      this.$nextTick(
        () =>
        (this.inputEvents = this.$processEvent(
          this.def.eventHandlers,
          this.def.id,
          this
        ))
      );

    this.$watch(
      "model",
      async () => {
        let erMsg = await Promise.all(
          (this.def.inActiveCollection &&
            this.def.inActiveCollection
              .map(async (ia) =>
                (await this.$eval(ia)) ? this.$t(ia.message) : null
              )
              .filter((er) => er)) ||
          []
        );
        erMsg = erMsg.filter((a) => a);
        const sem = await Promise.all(this.scriptErrorMessages);
        this.ErrorMessages = [...sem, ...erMsg];
        this.ErrorMessages = this.ErrorMessages.filter((er) => er);
      },
      { deep: true, immediate: true }
    );
    this.$watch(
      "$store.getters.getCurrentForm.model",
      async () => {
        let erMsg = await Promise.all(
          (this.def.inActiveCollection &&
            this.def.inActiveCollection
              .map(async (ia) =>
                (await this.$eval(ia)) ? this.$t(ia.message) : null
              )
              .filter((er) => er)) ||
          []
        );
        erMsg = erMsg.filter((a) => a);
        const sem = await Promise.all(this.scriptErrorMessages);
        this.ErrorMessages = [...sem, ...erMsg];
        this.ErrorMessages = this.ErrorMessages.filter((er) => er);
      },
      { deep: true, immediate: true }
    );

  },
  beforeDestroy() {
    this.Actionres = {}
  },
  methods: {
    isActionActive(action,payload){
      // console.log('isActionActive(',action,',',payload,')');
      const fndAction = this.actionActiveList.find(n=>n.action==action&& isEqual(n.payload,payload));

      return fndAction ? true:false;
    },
    addActionToActiveList(action,payload){
      // console.log('addActiontoActiveList(',action,',',payload,')');
      const n = {
        action:action,
        payload:payload
      }
      if(!this.isActionActive(action,payload)){
        this.actionActiveList.push(n);
      }

    },
    removeActionFromActiveList(action,payload){
      // console.log('removeActionFromActiveList(',action,',',payload,')');
      const n = {
        action:action,
        payload:payload
      }
      for (let i = this.actionActiveList.length - 1; i >= 0; i--) {
        if (isEqual(this.actionActiveList[i], n)) {
          this.actionActiveList.splice(i, 1);
        }
      }

    },
    mergeListeners() {
      if (Object.keys(this.$listeners).length === 0) return this.inputEvents;
      let object = { ...this.$listeners };
      for (let e in this.inputEvents) {
        if (e in object) {
          object[e].fns = Array.isArray(this.$listeners[e].fns)
            ? [...this.$listeners[e].fns, ...this.inputEvents[e]]
            : [this.$listeners[e].fns, ...this.inputEvents[e]];
        } else {
          object[e] = this.inputEvents[e];
        }
      }
      return object;
    },
    async checkVisibleByState(state) {

      if (this.def.action && this.currentState?.transitions) {
        const visibleAction = await this.$checkVisibility(this.def);
        this.visible = state?.transitions === undefined ? false : state.transitions
          ? visibleAction &&
          state?.transitions.some(
            (tr) => tr.action?.name === this.def.action.id
          )
          : false;
      } else if (state && this.def.name === "fcaSubmitButton") {
        const formMode = this.$formMode;
        const submitBtn =
          formMode === "fmEdit"
            ? "ECore.Cmn.actEdit"
            : formMode === "fmCreate"
              ? ["ECore.Cmn.actCreate", "ICore.PolicyAdmin.actCreateEndorse"]
              : formMode === "fmDelete"
                ? "ECore.Cmn.actDelete"
                : null;
        // this.visible = state.transitions.some(tr => tr.action.name === submitBtn || this.def.action?.id);
        this.visible = state?.transitions === undefined ? false : state?.transitions.some((tr) =>
          Array.isArray(submitBtn)
            ? submitBtn.includes(tr.action?.name)
            : tr.action?.name === submitBtn || this.def.action?.id

        );
      }
    },
    async click() {
      // const store = (await import("@/store")).default;
      if (!this.def) return;
      if (this.def.target?.name === "ECore.Def.DefEnums.atCustom") {
        return;
      } else if (this.def.target?.name === "ECore.Def.DefEnums.atModal") {
        const model = this.Model && JSON.parse(JSON.stringify(this.Model));
        if (
          this.def.targetMode &&
          this.def.targetMode.name === "ECore.Def.DefEnums.fmEdit"
        ) {
          const result = await this.$store.dispatch(
            "SHOW_MODAL",
            await this.$target(this.def, model)
          );
          console.log("Modal closed with model = ", result);
          if (result.modalResult === "ECore.Def.DefEnums.mrSubmit") {
            this.$emit("onSubmitEdit", result.model);
            this.assign(this.Model, result.model);
          }
        } else if (
          this.def.targetMode &&
          this.def.targetMode.name === "ECore.Def.DefEnums.fmCreate"
        ) {
          const result = await this.$store.dispatch(
            "SHOW_MODAL",
            await this.$target(this.def)
          );

          if (result.modalResult === "ECore.Def.DefEnums.mrNo") {

            Object.keys(result.model).forEach((item, index) => (item == 'ID') ? null : this.$set(this.model, item, result.model[item]))
          }
          if (result.modalResult === "ECore.Def.DefEnums.mrSubmit") {
            if (typeof this.$parent.pushToModel === "function") {
              this.$parent.pushToModel(result.model);
            } else {
              if (this.def.grid) {
                if (this.def.grid.checkValidationBeforePush) {
                  const validcheck = await this.checkValidationBeforePush(result)
                  if (validcheck.length === 0) {
                    const res = result.model.results ?? result.model;
                    this.$eventBus.$emit(`${this.def.grid.id}-onSubmit`, res);
                  }
                  else {
                    return
                  }
                }
                else {
                  const res = result.model.results ?? result.model;
                  this.$eventBus.$emit(`${this.def.grid.id}-onSubmit`, res);
                }

              } else {
                this.$emit("onSubmit", result.model);
              }
            }
          }
        } else if (
          this.def.targetMode &&
          this.def.targetMode.name === "ECore.Def.DefEnums.fmDelete"
        ) {
          const target = await this.$target(this.def, this.deepCopy(model));
          if (!target) {
            this.Model.delete();
            return;
          }
          const result = await this.$store.dispatch(
            "SHOW_MODAL",
            await this.$target(this.def, this.deepCopy(model))
          );
          console.log("Modal closed with model = ", result);
          if (result.modalResult === "ECore.Def.DefEnums.mrSubmit") {
            this.$emit("onSubmitDelete", result.model);
            // this.$emit("onAfterSubmit", { submitMethod: "delete", result: result.model });
            typeof this.Model.delete === "function" && this.Model.delete();
          }
        } else if (
          this.def.targetMode &&
          this.def.targetMode.name === "ECore.Def.DefEnums.fmView"
        ) {
          await this.$store.dispatch(
            "SHOW_MODAL",
            await this.$target(this.def, this.deepCopy(model))
          );
        }
      } else if (this.def?.target?.name === "ECore.Def.DefEnums.atPage") {
        const model = this.Model && JSON.parse(JSON.stringify(this.Model));
        if (
          this.def.targetMode &&
          this.def.targetMode.name === "ECore.Def.DefEnums.fmEdit"
        ) {
          const result = await this.$store.dispatch(
            "SHOW_PAGE",
            await this.$target(this.def, this.deepCopy(model))
          );
          console.log("page closed with model = ", result);
          if (result.pageResult === "ECore.Def.DefEnums.mrSubmit") {
            this.assign(this.Model, result.model);
          }
        } else if (
          this.def.targetMode &&
          this.def.targetMode.name === "ECore.Def.DefEnums.fmCreate"
        ) {
          const result = await this.$store.dispatch(
            "SHOW_PAGE",
            await this.$target(this.def)
          );

          console.log("page closed with model = ", result);
          if (result.pageResult === "ECore.Def.DefEnums.mrSubmit") {
            if (typeof this.$parent.pushToModel === "function") {
              this.$parent.pushToModel(result.model);
            } else {
              this.$emit("onSubmit", result.model.result || result.model);
            }
          }
        } else if (
          this.def.targetMode &&
          this.def.targetMode.name === "ECore.Def.DefEnums.fmDelete"
        ) {
          const result = await this.$store.dispatch(
            "SHOW_PAGE",
            await this.$target(this.def, this.deepCopy(model))
          );
          console.log("page closed with model = ", result);
          if (result.pageResult === "ECore.Def.DefEnums.mrSubmit") {
            this.$emit("onAfterSubmit", {
              submitMethod: "delete",
              result: result.model,
            });
            this.Model.delete();
          }
        } else if (
          this.def.targetMode &&
          this.def.targetMode.name === "ECore.Def.DefEnums.fmView"
        ) {
          await this.$store.dispatch(
            "SHOW_PAGE",
            await this.$target(this.def, this.deepCopy(model))
          );
        }
      } else if (this.def.action) {
        if (this.def.action.confirmMessage) {
          const { confirm } = await this.$store.dispatch(
            "SHOW_CONFIRM_MESSAGE",
            { title: this.$t(this.def.action.confirmMessage) }
          );
          if (!confirm) return;
        }

        const { form, model } = this.$store.getters.getActiveTab;
        if (form.id) {
          let args = {};
          if (this.def.actionPayloadExpr) {
            const result = await this.$eval(this.def.actionPayloadExpr);
            const res = Object.entries(result).reduce((acc, [key, value]) => {
              acc[key] = value === undefined ? '' : value;
              return acc;
            }, {});
            Object.assign(args, res);
          } else {
            Object.assign(args, {
              [form.product ? "PolicyID" : "ID"]: model.ID
            });
          }
          const version = this.$route.params.id === "$new" ? "latest" : typeof this.$route.params.id === "string" ? this.$route.params.id.split(':').pop() : this.$route.params.id

          // }
          let ID =
            `${this.$store.getters.getCurrentForm.model.ID}${typeof version === "string" ? ":" + version : ""}`;
          ID === "not_set" ? this.model.ID : ID;


          // const actionID = form.product ? `${model.ID}:latest` : model.ID;
          // const res = await invokeAction(form.id, ID, this.def.action.id, args);
          const formID = this.currentFormFinder?.formId || form.id
          let invokeActionId;
          if (ID === "not_set" || ID === "undefined:not_set") {
            if (this.$store.getters.getActiveTab.form.product) {
              invokeActionId = this.$route.params.id === undefined ? ID : this.$route.params.id;
            } else {
              invokeActionId = this.model.ID;
            }
          } else {
            invokeActionId = ID;
          }
          
          const id = invokeActionId === "$new" ? this.model.ID || -1 : invokeActionId || this.$store.getters.getActiveTab.model.ID ||-1 ;
          const action = this.def.action.id ?? this.def.action.name ;
          const payload = args;

          // if(!this.isActionActive(action,payload)){
          //   this.addActionToActiveList(action,payload);
          // console.log('Start Run Action....');
          const res = await invokeAction(formID, id , action, payload);
          if (res) {
            this.$set(this, "Actionres", res)
          //   this.removeActionFromActiveList(action,payload);
          // }
if (
  this.def.printTemplates && 
  !this.def.printTemplates.some(pt => pt.tags)
) {
  await this.fnPrintPolicy();
}
 
let state;

const { 
  asbRefreshSM, 
  asbRefetchModel,
  asbUpdateSearchPage
} = this.def.action.successBehaviour || {};
asbRefreshSM && (state = await this.updateStateMachine(form.id, ID));
asbRefetchModel && (await this.updateFormModel(state, form, ID));
// console.log("ttt",this.model)
if (asbUpdateSearchPage) {
  const routeName = this.$store.getters.getCurrentForm?.route?.name;

  if (routeName) {
    this.$eventBus.$emit(`UpdateSearchPage-${routeName}`);
  }
}
this.$eventBus.$emit(`${this.def.id}-action-success-complete`, {
  success: true,
  actionId: this.def.id
});
if (
  this.inputEvents?.custom &&
  "onAfterActionSuccess" in this.inputEvents.custom
) {
  this.$nextTick(() =>
    this.$eventBus.$emit(`${this.def.id}-onAfterActionSuccess`)
  );
}
if (this.def.targetForm && this.def.name !== "CalcPrm") {
  await this.openFormWithAction();
}
this.$store.dispatch("SHOW_SNACKBAR", {
  message: this.$t("ECore.Cmn.FixedMsg.FormSubmit"),
  color: "success",
});


          }
        }
      } else if (
        this.def.name !== "fcaCancelButton" &&
        this.def.name !== "fcaSubmitButton"
      ) {
        const modes = [
          "ECore.Def.DefEnums.fmCreate",
          "ECore.Def.DefEnums.fmSearch",
        ];
        let model = {
          ID: !modes.includes(this.def.targetMode?.name)
            ? this.Model?.ID
            : undefined,
        };
        if (this.def.actionType?.name === "ECore.Def.DefEnums.atRowAction") {
          model = { ...this.model, ...model };
        }
        const target = await this.$target(this.def, model);
        if (!target) return;
        const result = await this.$store.dispatch("SHOW_APP_TAB", target);
        if (result) {
          this.$eventBus.$emit(`${this.def.id}-onTabClosed`, result);
        }
      }
    },
    async updateStateMachine(formId, ID) {
      // const { id } = this.$getProductInfo();
      this.updateFormStateMachineData(formId, ID)
      const data = { formId, ID }
      this.$eventBus.$emit('Update-Form-State-Machine', data);
      // this.$store.state.stateMachine[formId] = state;
      // return state;
    },
    async updateFormModel(currentState, form, ID) {
      const endorseRegex =
        /:+(([0-9]+)|(\bfirst\b)|(\bnone\b)|(\bunversioned\b)|(\bpropagate\b)|(\bcurrent\b)|(\blatest\b)|(\bdraft\b)|(\ball\b))/;
      ID = endorseRegex.test(ID.toString()) ? ID : `${ID}:first`;
      const entity = await fetchFormData(form.origin?.name, ID, form.id);
      this.$eventBus.$emit("ButtonRenderVisibility", {state: currentState, formID: form.id});
      this.$eventBus.$emit("changeModelOnAction", entity);
      this.$eventBus.$emit("RenderComponent");
    },
    async openFormWithAction() {
      const target = await this.$target(this.def, this.model);
      if (!target) return;
      return await this.$store.dispatch("SHOW_APP_TAB", target);
    },
    deepCopy(value, copied = []) {
      if (!value) return value;
      else if (Array.isArray(value)) return value.map(this.deepCopy, copied);
      else if (typeof value === "object") {
        if (copied === 0) {
          copied = []
        }
        if (!copied && !copied.includes(value)) {
          const v = Object.keys(value)
            .filter((k) => k !== "__proxy__")
            .reduce(
              (o, k) => ({ [k]: this.deepCopy(value[k], copied), ...o }),
              {}
            );
          copied.push(v);
          return v;
        } else return value;
      } else return value;
    },

    assign(target, source) {
      if (source) {
        for (let i of Object.keys(target))
          if (Array.isArray(target[i]) && !(i in source)) delete target[i];
        for (let k of Object.keys(source)) this.$set(target, k, source[k]);
      }

      return target;
    },
    async fnPrintPolicy() {
      const { form, model } = this.$store.getters.getActiveTab;
      let queryParam = "";
      const product = {
        ID: `product=${this.$store?.getters?.getActiveTab?.form?.product?.name || undefined
          }`,
        Title: `productTitle=${this.$t(
          this.$store?.getters?.getActiveTab?.form?.product || undefined
        )}`,
      };
      if (product.ID) {
        queryParam = `?${product.ID}&${product.Title}&printMark=${this.def.printTemplates &&
          this.def.printTemplates[0]?.printMark?.name?.split(".").pop()
          }`;
      }
      const endorseNo =
        this.$route.params.id.toString()?.split(":")?.length > 1
          ? this.$route.params.id.toString()?.split(":")?.pop()
          : "";
      const templateName = this.def?.printTemplates[0]?.templateName ?? "main";
      let idWithEndorse = `${model.ID}:first`;
      if (endorseNo) {
        idWithEndorse = `${model.ID}:${endorseNo}`;
      }

      const responsefile = await getReport(
        form.id,
        templateName,
        idWithEndorse,
        queryParam
      );
      var blobFile = new Blob([responsefile.data], { type: "application/pdf" });
      var url = URL.createObjectURL(blobFile);
      window.open(url, "_blank");
    },
    async checkValidationBeforePush(result) {
      const DepPartyIDs = result.model.results.map(m => m.DepPartyID)
      const res = await invokeFn("ICore.PartyAdmin.csmParty.fnGetPartiesWithoutBankAccountAsync", { Ids: DepPartyIDs })
      return res
    },
    updateFormStateMachineData(state) {
      this.$eventBus.$emit('Update-Form-State-Machine', state);
    },
    formValidation(){
      let isValid = true
      let p = this.$parent;
      while (p) {
        if (typeof p.formValidate == "function") {
          isValid =  p.formValidate();
        }
        p = p.$parent;
      }

      return isValid
    }
  },
};
</script>

<style>
.btnCmn {
  font-family: "IranYekanRegular";
  font-size: 14px;
}

.btn,
.v-btn {
  letter-spacing: 0 !important;
  font-size: 12px !important;
}

.btnRowAction {
  margin: 0 !important;
  padding: 0 !important;
  font-family: "IranYekanRegular";
  font-size: 14px;
}

.v-btn__content {
  margin: 0 !important;
  padding: 0 !important;
  border: none;
}

/* DARK MODE */
.theme--dark .v-btn {
  color: #fff !important;
}

.theme--dark .v-btn .v-btn__content {
  color: #fff !important;
}

.theme--dark .v-btn .v-icon {
  color: #fff !important;
}
</style>
